import { Component, inject } from '@angular/core';
import { IonButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { ReactiveFormsModule } from '@angular/forms';
import { getRequestOtpDtoFormGroup, WorkAuthenticationV2Service, WorkRequestOtpDto } from '@work-frontend-monorepo/work-rest-api';
import { lastValueFrom } from 'rxjs';
import { ButtonComponent, LogoComponent } from '@work-frontend-monorepo/work-ui/layout';
import { InputFieldComponent } from '@work-frontend-monorepo/work-ui/forms';
import { ExceptionHandlingService, LoggerService } from '@work-frontend-monorepo/work-ui/services';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'sfg-app-auth-login-page',
  templateUrl: './auth-login-page.component.html',
  styleUrls: ['./auth-login-page.component.scss'],
  standalone: true,
  imports: [
    IonContent,
    InputFieldComponent,
    ButtonComponent,
    ReactiveFormsModule,
    InputFieldComponent,
    ButtonComponent,
    InputFieldComponent,
    LogoComponent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    RouterLink,
    TranslatePipe,
  ],
})
export class AuthLoginPageComponent {
  private readonly exceptionHandlingService = inject(ExceptionHandlingService);
  private readonly workAuthenticationV2Service = inject(WorkAuthenticationV2Service);
  private readonly router = inject(Router);

  protected formGroup = getRequestOtpDtoFormGroup();

  protected async login() {
    try {
      const response = await lastValueFrom(
        this.workAuthenticationV2Service.authenticationV2ControllerRequestOtp({
          body: this.formGroup.value as WorkRequestOtpDto,
        }),
      );
      if (response.success) {
        const encodedMobileNumber = this.getUrlEncodedPhoneNumberForUrlTransfer(this.formGroup.value.mobileNumber);
        await this.router.navigateByUrl(`/auth/verify-otp?mobilenumber=${encodedMobileNumber}`);
      }
    } catch (loginFailedException) {
      this.exceptionHandlingService.handleExceptionWithAlert('loginFailedException', loginFailedException);
    }
  }

  private getUrlEncodedPhoneNumberForUrlTransfer(mobileNumber: string | null | undefined) {
    if (!mobileNumber) {
      throw new Error('Mobile number is required');
    }
    try {
      return encodeURIComponent(mobileNumber.trim());
    } catch (mobileNumberRequiredException) {
      LoggerService.ERROR(this, 'mobileNumberRequiredException', mobileNumberRequiredException);
      throw new Error('Mobile number is required');
    }
  }
}
